<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="130">
                <FormItem :label="$t('dep_cname')">
                    <Input v-model="dep_cname" disabled/>
                </FormItem>
                <FormItem :label="$t('user_code')" prop="user_code">
                    <Input search v-model="formData.user_code" :placeholder="$t('input')" @on-keyup="clearUserInfo"  @on-search="searchUserInfo"/>
                </FormItem>
                <FormItem :label="$t('user_cname')">
                    <Input v-model="formData.user_cname" disabled/>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    dep_id:'',
                    u_id: '',
                    user_code: '',
                    user_cname: ''
                },
                rule: {
                    u_id: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_code: [{required: true, message: this.$t('input'), trigger: 'blur'}]
                },
                dep_cname: ''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.dep_id = this.$base.getRequest().id;
            this.dep_cname = this.$base.getRequest().dep_cname;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){
                var url = "dep/add-user";
                if(this.formData.u_id == ""){
                    this.$base.alertErr(this.$t('input_user'));
                    return;
                }
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            },
            clearUserInfo: function() {
                this.formData.user_cname = "";
                this.formData.u_id = "";
            },
            searchUserInfo: function () {
                this.clearUserInfo();

                this.$base.showLoading();
                this.$request.sendPost('dep/get-add-user',this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        if(data){
                            this.formData.user_cname = data.user_cname;
                            this.formData.u_id = data.u_id;
                        }
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/dep/dep_user.vue